import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { Navbar } from "../../../../Components/Navbar/Navbar";
import { Footer } from "../../../../Components/Footer/footer";
import "./style.css";

interface PodcastEpisode {
  id: string;
  title: string;
  description: string;
  date: string;
  youtube_url: string;
  image_url?: string;
}

export function PodcastEpisodePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [episode, setEpisode] = useState<PodcastEpisode | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "podcast_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        const match = (data.episodes || []).find(
          (item: PodcastEpisode) => item.id === id
        );
        setEpisode(match || null);
      }
    };
    fetchData();
  }, [id]);

  if (!episode) {
    return (
      <div className="page-container">
        <Navbar />
        <div className="page-content">
          <h1>Episodul nu a fost găsit</h1>
          <button onClick={() => navigate(-1)}>Înapoi</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navbar />
      <div className="page-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Înapoi
        </button>

        {episode.image_url && (
          <img src={episode.image_url} alt="Imagine episod" className="episode-image" />
        )}

        <h1>{episode.title}</h1>
        <p className="episode-date">
          {new Date(episode.date).toLocaleDateString("ro-RO", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <div className="episode-description">{episode.description}</div>

        <div className="youtube-wrapper">
          <iframe
            src={episode.youtube_url.replace("watch?v=", "embed/")}
            title={episode.title}
            allowFullScreen
            frameBorder="0"
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
